/** The v5 facade: one persisted place/units store, shared with Studio and widgets. */
export { useApp, allPlaces, selectedPlace, toSaved, type SavedPlace } from '../app/store'
import { useApp, allPlaces } from '../app/store'
import { timeCursor } from '../app/time/cursor'
import { useShallow } from 'zustand/react/shallow'

export function usePlaces() { return useApp(useShallow(allPlaces)) }

export function selectPlace(id: string): void {
  if (!allPlaces(useApp.getState()).some((place) => place.id === id)) return
  // Both writes precede React's next commit; no old-place time can leak into the new reading.
  timeCursor.setPlace(id)
  useApp.getState().select(id)
}

export function stepPlace(direction: number): void {
  const state = useApp.getState()
  const places = allPlaces(state)
  const i = Math.max(0, places.findIndex((place) => place.id === state.selectedId))
  selectPlace(places[(i + direction + places.length) % places.length].id)
}
